<span class="cp-title-widget" style="text-align: center;">{{ literalsCp?.strPedidoExtra | uppercase }}</span>

<div class="po-row" style="margin-top: 10px">
  <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
    <cp-gauge class="cp-font-normal" [value]="taskOrderExtra.percentage" [Kind]="Kind" [startlegend]="literalsCp?.strEntregue" [endlegend]="literalsCp?.strPedido"></cp-gauge>
  </div>
</div>
<div class="po-row" style="margin-top: 18px;">
  <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12" style="line-height: 1;">
    <span class="cp-info-labels">{{ literalsCp?.strPedido }}</span><span>{{ taskitem.getFormattedNumber(taskOrderExtra.orderextravalue) }}</span>
  </div>
</div>
<div class="po-row" style="margin-top: 3px;">
  <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12" style="line-height: 1;">
    <span class="cp-info-labels">{{ literalsCp?.strEntregue }}</span><span>{{ taskitem.getFormattedNumber(taskOrderExtra.orderextradelivered) }}</span>
  </div>
</div>
<div class="po-row np">
  <hr class="cp-div-line np po-xl-12 po-lg-12 po-md-12 po-sm-12" />
</div>
<div class="po-row np cp-div" style="margin-top: 22px;">
  <span class="cp-div-rectangle" style="margin-left: 4px;">
    <span style="font-size: 14px;">{{ literalsCp?.strPago | lowercase}}</span>
  </span>
  <span class="cp-font-bold"
    style="font-size: 14px; margin-left: 8px;">{{ taskitem.getFormattedNumber(taskOrderExtra.orderextrapaid) }}</span>
</div>

<po-loading-overlay [hidden]="isHideLoading">
</po-loading-overlay>


